/*
	Nastavuje elementu rozbalovaci funcnost:
		block: rozbalovaci element,
		button: tlacitko pro rozbalovani,
		collapsedHeight: vyska sbaleneho bloku,
		expandedHeight: vyska rozbaleneho bloku

	Pouziva se v:
		- sportmod-today-results.js
*/

interface CollapsibleProps {
    block: HTMLElement;
    button: HTMLButtonElement;
    collapsedHeight?: number;
    expandedHeight: number;
}

interface ToggleHandlers {
    collapseHandler: () => void;
    expandHandler: () => void;
}

export const createCollapsibleBlock = (props: CollapsibleProps) => {
    const state = {
        block: props.block,
        button: props.button,
        collapsedHeight: props.collapsedHeight || 0,
        expandedHeight: props.expandedHeight,
        isCollapsed: true
    };

    const collapse = (callback: () => void): void => {
        state.block.style.height = `${state.collapsedHeight}px`;
        callback();
    };

    const expand = (callback: () => void): void => {
        state.block.style.height = `${state.expandedHeight}px`;
        callback();
    };

    const setToggleButtonClickListeners = (handlers: ToggleHandlers): void => {
        const onClick = () => {
            if (state.isCollapsed) {
                expand(handlers.expandHandler);
            } else {
                collapse(handlers.collapseHandler);
            }
            state.isCollapsed = !state.isCollapsed;
        };

        state.button.addEventListener('click', onClick);
    };

    return {
        setToggleButtonClickListeners
    };
};


